/** @format */

import React, { useContext, useState } from 'react';
import DispatchContext from '../../DispatchContext';
import StateContext from '../../StateContext';
import IconButton from '@mui/material/IconButton';
import PublicIcon from '@mui/icons-material/Public';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Grid from '@mui/system/Unstable_Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import { bgColorButtonTitle, bgColor } from '../Utils/sytles';

interface SearchComponentProps {
	message?: string;
}
interface SearchChangeEvent extends React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> {}

const SearchMobile: React.FC<SearchComponentProps> = ({ message }) => {
	const appDispatch = useContext(DispatchContext);
	const appState = useContext(StateContext);
    const [timer, setTimer] = useState(null)
    const matches = useMediaQuery('(min-width:900px)');


    const onSearchChangeHandler = (event: SearchChangeEvent): void => {
        event.stopPropagation(); // Stop event propagation
        const inputValue: string = event.target.value;
        clearTimeout(timer)
        const newTimer = setTimeout(() => {
            appDispatch({
                type: 'searchAction',
                searchEventValue: inputValue,
            });
          }, 1000)
          setTimer(newTimer)
        // if user has clear the search box with empty value
        
    };



    function toggleDialogBox(boxType: string) {
		appDispatch({ type: 'openDialogBox', value: boxType });
	}

	function toggleSatLayer(value: boolean) {
		appDispatch({ type: 'TOGGLE_SAT_LAYER', value: value });
	}

	return (
		<Grid container spacing={0} 
            sx={{ display: 'flex', 
            
             }}>
			<Grid
				xs={12}
				sx={{
					display: 'flex',
					height: '60px',
					justifyContent: 'center',
					alignItems: 'center',
                    marginLeft: '15px',
				}}
			>
				<TextField
					hiddenLabel
					size="small"
					placeholder="search for stations"
					sx={{
						width: '270px',
						fontStyle: 'italic',
						height: '20px',
					}}
					onChange={(e) => {
						onSearchChangeHandler(e);
					}}
					InputProps={{
						style: {
							border: '1px solid #cccccc',
							height: '35px',
							padding: '0px 0px 0px 0px',
							backgroundColor: 'gray',
						},
						startAdornment: (
							<InputAdornment position="start">
								<IconButton>
									<SearchIcon />
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			</Grid>
			<Grid
				xs={12}
				sx={{
					display: 'flex',
					height: '40px',
					gap: '10px',
					justifyContent: 'center',
					alignItems: 'center',
                    marginLeft: '15px',
				}}
			>
				<Chip
					icon={<PublicIcon />}
					label="Filters"
					sx={{
						color: bgColorButtonTitle,
						backgroundColor: bgColor,
						height: '30px',
                        border: '2px solid #4cadc5',
					}}
                    onClick={() => {   
                        matches ? appDispatch({ type: 'togleSelectModal'}): 
                            toggleDialogBox('filters')
                    }}
				/>
				<Chip
					icon={<WatchLaterIcon />}
					label="Last"
					sx={{
						color: bgColorButtonTitle,
						backgroundColor: bgColor,
						height: '30px',
                        border: '2px solid #4cadc5',
					}}
                    onClick={() => {   
                        if (matches) {
                            appDispatch({ type: 'togleProjectsModal' });
                            appDispatch({ type: 'setTimelinePanel' });
                        } else {
                            toggleDialogBox('timeline')
                        }
                    }}
				/>
				<Chip
					icon={<BookmarkIcon />}
					label="Fav"
					sx={{
						color: bgColorButtonTitle,
						backgroundColor: bgColor,
						height: '30px',
                        border: '2px solid #4cadc5',
					}}
                    onClick={() => {   
                        if (matches) {
                            appDispatch({ type: 'TOGGLE_BOOKMARK_PANEL', value: !appState.bookmarkPanel });
                            appDispatch({ type: 'togleProjectsModal' });
                            appDispatch({ type: 'setTimelinePanel' });
                        } else {
                            toggleDialogBox('bookmarks')
                        }
                    }}
				/>
				<Chip
					icon={<PublicIcon />}
					label="Sat"
					sx={{
						color: bgColorButtonTitle,
						backgroundColor: bgColor,
						height: '30px',
                        border: '2px solid #4cadc5',
					}}
                    onClick={() => {   
                       toggleSatLayer(!appState.satLayer)
                    }}
				/>
				
			</Grid>
		</Grid>
	);
};

export default SearchMobile;